import React, { useEffect } from 'react'
import { SafeAreaView } from 'react-native'
import PropTypes from 'prop-types'

export default function InvalidStack(props) {
  const { webStackToLoad } = props
  useEffect(() => {
    window.ReactNativeWebView.postMessage(`invalidStack;${webStackToLoad};${window.location.href}`)
  })
  return (
    <SafeAreaView style={{ flex: 1 }} />
  )
}

InvalidStack.propTypes = {
  webStackToLoad: PropTypes.string,
}

InvalidStack.defaultProps = {
  webStackToLoad: '',
}
